import {
  PenLine, Sparkles, AlignLeft, Heading, FileText, Megaphone, Lightbulb,
  Globe, Palette, Brush, Image as ImageIcon, Bot, Wand2,
} from "lucide-react";

/**
 * Correspondance nom d'icône (renvoyé par le backend) → composant lucide.
 *
 * Le backend ne connaît que des NOMS : il ne peut pas envoyer un composant
 * React, et importer lucide dynamiquement embarquerait toute la
 * bibliothèque dans le bundle. Une action dont l'icône n'est pas encore
 * cartographiée retombe sur la baguette magique plutôt que de casser le
 * rendu — ajouter une action côté serveur ne doit jamais exiger un
 * déploiement frontend pour rester affichable.
 */
const ICONS = {
  PenLine, Sparkles, AlignLeft, Heading, FileText, Megaphone, Lightbulb,
  Globe, Palette, Brush, Image: ImageIcon, Bot,
};

export const iconFor = (name) => ICONS[name] || Wand2;

export const CATEGORY_LABELS = {
  redaction: "Rédaction",
  marketing: "Marketing",
  seo: "Référencement",
  identite: "Identité visuelle",
};

export const categoryLabel = (key) => CATEGORY_LABELS[key] || "Autre";

/** Groupe les actions par catégorie, en conservant l'ordre du serveur. */
export function groupByCategory(actions) {
  const groups = [];
  for (const action of actions) {
    let group = groups.find((g) => g.key === action.category);
    if (!group) {
      group = { key: action.category, label: categoryLabel(action.category), actions: [] };
      groups.push(group);
    }
    group.actions.push(action);
  }
  return groups;
}

/**
 * Extrait le texte applicable d'un résultat, quel que soit son type — c'est
 * ce que la plupart des pages veulent coller dans un champ.
 */
export function resultToText(result) {
  if (!result) return "";
  if (result.type === "text" || result.type === "rich_text") return result.content || "";
  if (result.type === "suggestions") return (result.items || []).join("\n");
  if (result.type === "json") {
    const data = result.data || {};
    return Object.values(data).filter((v) => typeof v === "string").join("\n");
  }
  return "";
}
